import type { PropsWithChildren, FunctionComponent } from 'react'
import { LegacyVirtualCard } from '@/src/experiences/virtual-card/withVirtualCard/LegacyVirtualCard'
import { PlatformVirtualCardAccount } from '@/src/experiences/virtual-card/withVirtualCard/PlatformVirtualCardAccount'
import type { FreezeParams } from '@/src/app/main/(tabs)/card/card-management/virtual-card/freeze'
import { provideCardPlatform } from '@/src/experiences/card-platform/provideCardPlatform'
import type { CardShipmentStatus } from '@acre-rewards/lib'

export type VirtualCardComponent = FunctionComponent<{
  cardLoaded?: boolean
  paymentMethodsLoaded?: boolean
  cardAccountActive?: boolean
  /** it's not enough that the user has payment _methods_ because it isn't until there exists a payment _profile_ that we know the user has passed (plaid) verification */
  hasPaymentProfile?: boolean
  shipmentStatus?: CardShipmentStatus
  cardBackContent?: PropsWithChildren['children']
  freezeParams?: FreezeParams
}>

export const withVirtualCard = provideCardPlatform<VirtualCardComponent>(({ platform, ToWrap }) => {
  switch (platform) {
    case 'HIGHNOTE':
      return <LegacyVirtualCard ToWrap={ToWrap} />
    case 'LOANPRO':
      return <PlatformVirtualCardAccount ToWrap={ToWrap} />
    default:
      platform satisfies undefined
      return <ToWrap />
  }
})
